import React from "react";
import { Link } from "react-router-dom";
import PageLinks from "@/components/common/PageLinks";
import Preloader from "@/components/common/Preloader";
import FooterOne from "@/components/layout/footers/FooterOne";
import Header from "@/components/layout/headers/Header";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Support || gvkEDU",
  description:
    "Get help with gvkEDU — contact support for account, payment, and learning content questions.",
};

export default function SupportPage() {
  const [links] = React.useState([
    {
      title: "Home",
      target: "/",
    },
    {
      title: "Support",
      target: "/support",
    },
  ]);

  return (
    <div className="main-content">
      <MetaComponent meta={metadata} />
      <Preloader />
      <Header />
      <div className="content-wrapper js-content-wrapper overflow-hidden">
        <PageLinks links={links} />

        <section className="layout-pt-lg layout-pb-lg bg-white">
          <div className="container">
            <div className="row justify-center">
              <div className="col-xl-10 col-lg-11">
                <div className="text-dark-1">
                  <h1 className="text-45 fw-700 mb-30">Support</h1>
                  <p className="text-16 mb-30">
                    We&apos;re here to help you get the most out of gvkEDU. Reach
                    out through any of the channels below and we&apos;ll get back
                    to you as soon as we can.
                  </p>

                  <div className="privacy-content">
                    <section className="mb-40">
                      <h2 className="text-30 fw-600 mb-20">Contact Us</h2>
                      <p className="text-16 mb-15">
                        Prefer a quick reply? Email or WhatsApp are the fastest
                        ways to reach our team.
                      </p>
                      <div className="text-16 mb-15" style={{ paddingLeft: "20px" }}>
                        <p className="mb-10">
                          <strong>Email:</strong>{" "}
                          <a
                            href="mailto:info@gvkedu.com"
                            className="text-purple-1"
                          >
                            info@gvkedu.com
                          </a>
                        </p>
                        <p className="mb-10">
                          <strong>WhatsApp:</strong>{" "}
                          <a
                            href="https://wa.me/9985565894"
                            className="text-purple-1"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            +91 99855 65894
                          </a>
                        </p>
                        <p className="mb-10">
                          <strong>Organization:</strong> gvkEDU
                        </p>
                      </div>
                    </section>

                    <section className="mb-40">
                      <h2 className="text-30 fw-600 mb-20">What We Can Help With</h2>
                      <p className="text-16 mb-15">
                        Our support team can assist with:
                      </p>
                      <ul
                        className="text-16 mb-15"
                        style={{ paddingLeft: "30px" }}
                      >
                        <li className="mb-10">
                          <strong>Account &amp; login:</strong> OTP login issues,
                          profile updates, and account access
                        </li>
                        <li className="mb-10">
                          <strong>Purchases &amp; payments:</strong> Payment
                          failures, order status, and content unlock problems
                        </li>
                        <li className="mb-10">
                          <strong>Courses &amp; materials:</strong> Exam packs,
                          subject content, videos, and downloadable materials
                        </li>
                        <li className="mb-10">
                          <strong>Mock tests:</strong> Access, attempts, and
                          result-related questions
                        </li>
                        <li className="mb-10">
                          <strong>Technical issues:</strong> Playback problems,
                          page errors, and mobile or browser compatibility
                        </li>
                      </ul>
                    </section>

                    <section className="mb-40">
                      <h2 className="text-30 fw-600 mb-20">
                        Before You Contact Us
                      </h2>
                      <p className="text-16 mb-15">
                        To help us resolve your request faster, please include:
                      </p>
                      <ul
                        className="text-16 mb-15"
                        style={{ paddingLeft: "30px" }}
                      >
                        <li className="mb-10">
                          The email or WhatsApp number linked to your account
                        </li>
                        <li className="mb-10">
                          A short description of the issue and when it started
                        </li>
                        <li className="mb-10">
                          Screenshots or error messages, if available
                        </li>
                        <li className="mb-10">
                          Exam, material, or mock test name (when relevant)
                        </li>
                      </ul>
                    </section>

                    <section className="mb-40">
                      <h2 className="text-30 fw-600 mb-20">Response Time</h2>
                      <p className="text-16 mb-15">
                        We typically respond within 1–2 business days. During
                        peak exam seasons, replies may take a little longer —
                        thank you for your patience.
                      </p>
                    </section>

                    <section className="mb-40">
                      <h2 className="text-30 fw-600 mb-20">Privacy</h2>
                      <p className="text-16 mb-15">
                        For questions about how we handle your personal data,
                        please review our{" "}
                        <Link to="/privacy-policy" className="text-purple-1">
                          Privacy Policy
                        </Link>{" "}
                        or email us at{" "}
                        <a
                          href="mailto:info@gvkedu.com"
                          className="text-purple-1"
                        >
                          info@gvkedu.com
                        </a>
                        .
                      </p>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FooterOne />
      </div>
    </div>
  );
}
